module.exports = __webpack_public_path__ + "static/media/lamp.fa9ac09b.svg";